import { useCallback } from 'react';
import axios from 'axios';

export const useAddressValidation = () => {
  const validateAddress = useCallback(async (address) => {
    try {
      const response = await axios.post(
        '/geocoding/validate',
        { address },
        { timeout: 5000 }
      );
      
      return {
        formatted_address: response.data.formatted_address,
        latitude: response.data.coordinates.latitude,
        longitude: response.data.coordinates.longitude,
        address_components: response.data.address_components
      };
    } catch (error) {
      console.error('Address validation failed:', error);
      return null;
    }
  }, []);

  return { validateAddress };
};